import { render, staticRenderFns } from "./DetailsSectionStopsRoute.vue?vue&type=template&id=42dc13dd&"
import script from "./DetailsSectionStopsRoute.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionStopsRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports